
export const documentCategory = {
    company: "company",
    personal: "personal",
    attached: "attached"
}
export const docExtensionsStr = ["doc", "docm", "docx", "docxf", "dot", "dotm", "dotx", "epub", "fodt", "fb2", "htm", "html", "mht", "odt", "oform", "ott", "oxps", "pdf", "rtf", "txt", "djvu", "xml", "xps"];

export const cellExtensionsStr = ["csv", "fods", "ots", "xls", "xlsb", "xlsm", "xlsx", "xlt", "xltm", "xltx"];

export const slideExtensionsStr = ["fodp", "odp", "otp", "pot", "potm", "potx", "pps", "ppsm", "ppsx", "ppt", "pptm", "pptx"];


export const imageExtensionsStr = ["canvas", "gif", "jpg", "jpeg", "png", "tiff", "raw", "eps", "ai", "psd", "svg"]

export const videoExtensionsStr = ["mp4", "vob", "wmv", "wmz", "wms", "avi", "mkv", "flv", "osp", "vsdc", "mpeg-4", "check", "mov"]

export const audioExtensionsStr = ["avi", "cda", "aac", "adt", "adts", "m4a", "mp3", "wav", "wma", "flac", "aac", "ogg", "aiff", "alac"]

export const compressedExtensionsStr = ["rar", "7zip", "zip"]

export const threeDExtensionStr = ["stl", "obj", "iges", "step", "fbx", "dae", "3ds", "vrml", "x3d", "amf", "3mf", "blend"]

export const otherExtensionStr = ["bmp", "dif", "accdb", "accde", "accdr", "accdt", "aif", "aifc", "aiff", "aspx", "dll", "eml", "eps", "flv", "htm", "html", "ini", "iso", "jar", "mdb", "mid", "midi", "mpg", "msi", "mui", "pst", "pub", "rtf", "swf", "tif", "tiff", "tmp", "vsdm", "vsdx", "vss", "vssm", "vst", "vstm", "vstx", "wbk", "wks", "wmd", "wpd", "wp5", "amv", "3gp", "dat", "vcd", "camrec", "trec"]